import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import useWindowResize from 'pubweb-smokey/dist/hooks/useWindowResize';
import { ImageGridStyles, CuratedCollectionStyles } from './ImageGrid.styled';
import Button from '@components/Shared/Buttons/Button';
import { Card, CollectionCard } from './Cards';

const Wrapper = ({ sectionHeader, buttonText, buttonURL, children }) => (
  <>
    <h2>{sectionHeader}</h2>
    <div className="image-grid">
      <ul className="image-list">{children}</ul>
      {buttonURL && buttonText && (
        <Button nextJSUrl={buttonURL.trim()} linkComponent={Link}>
          {buttonText}
        </Button>
      )}
    </div>
  </>
);

Wrapper.propTypes = {
  sectionHeader: PropTypes.string,
  buttonText: PropTypes.string,
  buttonURL: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

const ImageGrid = ({
  imageSource,
  sectionHeader,
  images,
  buttonText,
  buttonURL,
}) => {
  const [mobileView, setMobileView] = useState(false);
  const [imageCount, setImageCount] = useState(4);

  const IMAGE_ASSET_TYPE = 'Image: Image Asset';
  const TARGET_BREAKPOINT = 1023;

  useWindowResize(() => {
    if (window.innerWidth > TARGET_BREAKPOINT) {
      setMobileView(false);
    } else {
      setMobileView(true);
    }
  }, [TARGET_BREAKPOINT]);

  useEffect(() => {
    if (imageSource === IMAGE_ASSET_TYPE) {
      setImageCount(mobileView ? 4 : 5);
    } else {
      setImageCount(9);
    }
  }, [mobileView, imageSource]);

  return (
    <div>
      {imageSource === IMAGE_ASSET_TYPE ? (
        <ImageGridStyles>
          <Wrapper
            sectionHeader={sectionHeader}
            buttonText={buttonText}
            buttonURL={buttonURL}
          >
            {images.slice(0, imageCount).map((p, i) => {
              let className = 'image-list-item';
              if (!mobileView && i === 2) {
                className += ' wide';
              }
              return (
                <Card
                  key={`img-grid-${i}`}
                  item={p}
                  index={i}
                  className={className}
                  isMobile={mobileView}
                />
              );
            })}
          </Wrapper>
        </ImageGridStyles>
      ) : (
        <CuratedCollectionStyles>
          <Wrapper
            sectionHeader={sectionHeader}
            buttonText={buttonText}
            buttonURL={buttonURL}
          >
            {images.slice(0, imageCount).map((p, i) => {
              return <CollectionCard key={`img-grid-${i}`} item={p} />;
            })}
          </Wrapper>
        </CuratedCollectionStyles>
      )}
    </div>
  );
};

export default ImageGrid;

ImageGrid.propTypes = {
  buttonText: PropTypes.string,
  buttonURL: PropTypes.string,
  imageSource: PropTypes.string,
  images: PropTypes.array,
  sectionHeader: PropTypes.string,
};
